import React, {Fragment,  useState, useEffect} from "react";
import { Table, Button } from "react-bootstrap";

import '../../table_report.css';

const TablaInf1_en_procesoTotal = ({datosRP1_en_procesoTotal}) => {
  
  if (datosRP1_en_procesoTotal === null) {
    return(
      <p>Seleccionar rango de fechas...</p>
    )
  } else if(datosRP1_en_procesoTotal !== null){
    return(
      <Fragment>
        <h4></h4>
        <p className="subtitulos">Proyectos y lotes iniciados (Análisis preliminar y en proceso)</p>
        <div>
          <Table className="tableExp" stripped bordered hover responsive="md" style={{ marginBottom: '30px' }}>
            <thead>
              <tr style={{backgroundColor:"rgb(0,174,195)", color:"white"}}>
                <th></th>
                <th>Lotes</th>
                <th>Proyectos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{fontWeight: 'bold'}}>En análisis preliminar</td>
                <td>{datosRP1_en_procesoTotal[0]?.suma_lotes_analisis_preliminar || 0}</td>
                <td>{datosRP1_en_procesoTotal[0]?.proyectos_analisis_preliminar || 0}</td>
              </tr>
              <tr>
                <td style={{fontWeight: 'bold'}}>En proceso</td>
                <td>{datosRP1_en_procesoTotal[0]?.suma_lotes_en_proceso || 0}</td>
                <td>{datosRP1_en_procesoTotal[0]?.proyectos_en_proceso || 0}</td>
              </tr>
              <tr style={{fontWeight: 'bold', backgroundColor: '#f5f5f5'}}>
                <td>Total iniciados</td>
                <td>{datosRP1_en_procesoTotal[0]?.suma_lotes || 0}</td>
                <td>{datosRP1_en_procesoTotal[0]?.suma_proyectos || 0}</td>
              </tr>
            </tbody>
          </Table>  
          {/* tabla original con .map()
          <Table className="tableExp" stripped bordered hover responsive="md" >
          <thead>
            <tr style={{backgroundColor:"rgb(0,174,195)", color:"white"}}>
              <th>Total lotes</th>
              <th>Total proyectos</th>
            </tr >
          </thead>
          <tbody>
            {datosRP1_en_procesoTotal.map((item, i)=>(
              <tr key={i}>
                <td>{item.suma_lotes}</td>
                <td>{item.suma_proyectos}</td>
              </tr>
            ))}
          </tbody>
          </Table>
          */}
        </div>
      </Fragment>
    )
  }
};


export default TablaInf1_en_procesoTotal;
